import { axiosManagerPageClient } from "service/managerPageFacebookService";

export interface IPostDepartmentContent {
  department_id: number;
  department_level2_id: number;
  link: string;
  page_name: string;
}

export async function postDepartment(content: IPostDepartmentContent) {
  try {
    const response = await axiosManagerPageClient.post(
      `/checking-links`,
      content
    );

    return response;
  } catch (error: any) {
    throw error.response?.data;
  }
}
